export default __webpack_public_path__ + "static/media/laser.23dba1cc.svg";